import type { ISwSettings } from "app/@types/ISwSettings";

const getHasNtFlowFromSwSettings = (swSettings: ISwSettings) => !!swSettings?.user?.customData?.NtFlow;

export const isNtFlowNew = (swSettings: ISwSettings) => {
    if (!getHasNtFlowFromSwSettings(swSettings)) {
        return false;
    }

    const ntFlow = swSettings.user.customData.NtFlow;

    return ntFlow.toLowerCase() === "new";
};
